<template>
  <panel-description
    icon_color="text-success"
    icon_character="fa-project-diagram"
    @click="$router.push(click)"
  >
    <div class="mr-3">
      <span class="h4"> {{ project_name }} </span>
      <ul>
        <li>
          {{ $t('created') }} <b> {{ project_creation_info }} </b>
        </li>
        <li>
          {{ $t('contains_overall') }} <b> {{ project_bricks_amount }} </b>
          {{ $t('bricks') }}
        </li>
        <!--         <li>
          <div class="line-clamp">
            {{ and_notably_sources }} <b> {{ project_sources_names }} </b>
          </div>
        </li> -->
        <li>
          <div class="line-clamp">
            {{ and_notably_sources }}
            <b style="white-space: pre-line;"> {{ project_sources_names }} </b>
          </div>
        </li>
        <li>
          <div class="line-clamp">
            {{ $t('project_administrators') }}
            <b style="white-space: pre-line;">{{ admin_users }}</b>
          </div>
        </li>
      </ul>
    </div>

    <template #button>
      <div class="d-flex align-items-center">
        <project-in-production-indicator
          :is_in_production="(value || {}).is_in_production"
        />
        <project-powered-button
          :value="value"
          :disabled="(value || {}).is_in_production"
        />
      </div>
    </template>
  </panel-description>
</template>

<!-- <template>
  <aiplatform-panel-description
    icon_color="text-success"
    icon_character="fa-project-diagram"
    @click="$router.push(click)"
  >
    <div>
      <span class="h4"> {{ project_name }} </span
      ><span>
        * {{ $t('created') }} <b> {{ project_creation_info }} </b>
      </span>
    </div>
    <div>
      * {{ $t('contains_overall') }} <b> {{ project_bricks_amount }} </b>
      {{ $t('bricks') }}
    </div>
    <div>
      * {{ and_notably_sources }} <b> {{ project_sources_names }} </b>
    </div>
    <div>
      * {{ $t('project_administrators') }} <b>{{ admin_users }}</b>
    </div>

    <template #button>
      <project-powered-button :value="value" />
    </template>
  </panel-description>
</template>
 -->
<style>
.line-clamp {
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  text-overflow: ellipsis;

  overflow: hidden;
  word-break: break-all;
}
</style>

<i18n>
{
  "en": {
    "contains_overall": "Contains overall",
    "and_notably_sources": "And notably sources",
    "and_no_sources": "And notably no sources.",
    "project_administrators": "Project administrators:"
  },
  "fr": {
    "contains_overall": "Comptabilise en tout",
    "and_notably_sources": "Et notamment les sources",
    "and_no_sources": "Et notamment aucune source.",
    "project_administrators": "Administrateurs du projet :"
  }
}
</i18n>

<script>
import _ from 'lodash'
import * as moment from 'moment'
import 'moment/locale/fr'

import { project_auth_groups_enum } from '@/utils.js'

import { mapGetters, mapState } from 'vuex'

import {
  subscription_mixin,
  client_encryption_mixin,
} from '@/components/mixin.js'
import ProjectInProductionIndicator from '@/components/project_in_production_indicator.vue'
import ProjectPoweredButton from '@/components/project_powered_button.vue'
import PanelDescription from './panel_description.vue'

// *****************************************************************************

export default {
  name: 'ProjectDescription',
  components: {
    PanelDescription,
    ProjectPoweredButton,
    ProjectInProductionIndicator,
  },
  mixins: [subscription_mixin, client_encryption_mixin],
  props: ['value'],
  data() {
    return {
      click: '/projects/' + (this.value || {}).uid + '/workflow',
    }
  },
  computed: {
    project_id() {
      return (this.value || {}).uid
    },
    project_name() {
      // '\xa0' == Non breaking space
      const res = (this.value || {}).name || '\xa0'
      return res
    },
    project_creation_info() {
      let res = (this.value || {}).creation_dt
      if (!_.isUndefined(res)) {
        res.locale(this.$store.state.locale)
        res = res.calendar()
      }
      return res
    },

    bricks_undeleted() {
      return this.automl_bricks_undeleted_object_per_project(this.project_id)
    },
    project_bricks_amount() {
      let res = '??'
      // console.log('this.value : ', JSON.stringify(this.value))
      if (!_.isUndefined(this.value)) {
        // console.log(
        //   'this.bricks_undeleted.lists :',
        //   JSON.stringify(this.bricks_undeleted)
        // )
        res = this.bricks_undeleted.lists.length
        // console.log('res : ', res)
      }
      return res
    },
    list_project_sources() {
      let res = []
      if (!_.isUndefined(this.value)) {
        for (let i in this.bricks_undeleted.lists) {
          let uid = this.bricks_undeleted.lists[i]
          let brick = this.bricks_undeleted.bricks[uid]
          if (brick.brick_name === 'sourcefile') {
            res.push(brick.name)
          }
        }
      }
      return res
    },
    and_notably_sources() {
      let res = ''
      let project_sources = this.list_project_sources
      if (_.isEmpty(project_sources)) {
        res = this.$t('and_no_sources')
      } else {
        res = this.$t('and_notably_sources')
      }
      return res
    },
    project_sources_names() {
      let res = '??'
      let project_sources = this.list_project_sources
      if (_.isEmpty(project_sources)) {
        res = '\n \n \n'
      } else {
        res = project_sources.join(', ')
      }
      return res
    },
    project_powered_icon() {
      return this.project_powered
        ? this.project_running
          ? 'fas fa-sync-alt fa-fw synaplus-cosmo-spinpause'
          : 'fas fa-pause fa-fw'
        : 'fas fa-play fa-fw'
    },
    project_powered_variant() {
      return this.project_powered
        ? this.project_running
          ? 'primary'
          : 'success'
        : 'outline-danger'
    },
    project_powered() {
      let res = !(_.isEmpty(this.value) || this.value.is_paused)
      return res
    },
    project_running() {
      let project_id = this.value.project_id
      let res =
        !_.isUndefined(project_id) &&
        project_id === this.platform_status.current_running_project_id
      return res
    },
    project_rights() {
      let res = _.map(
        this.automl_project_rights_undeleted_object.lists || [],
        v => this.automl_project_rights_undeleted_object.project_rights[v]
      )
      return res
    },
    users() {
      let res = _.map(
        this.automl_users_undeleted_object.lists || [],
        v => this.automl_users_undeleted_object.users[v]
      )
      return res
    },
    admin_users() {
      const relevant_project_rights = _.filter(this.project_rights, {
        project_id: this.project_id,
        project_group_id: project_auth_groups_enum.admin,
      })
      const relevant_user_ids = _.map(relevant_project_rights, 'user_id')
      const non_deleted_relevant_user_ids = _.intersection(
        relevant_user_ids,
        this.automl_users_undeleted_object.lists || []
      )
      const users = _.map(
        non_deleted_relevant_user_ids,
        v => this.automl_users_undeleted_object.users[v]
      )
      let usernames = _.map(users, x => this.client_decrypt_string(x.username))
      usernames.sort()
      let res

      if (_.isEmpty(usernames)) {
        res = '\n \n \n'
      } else {
        res = usernames.join(', ')
      }

      return res
    },
    ...mapGetters([
      'automl_bricks_undeleted_object_per_project',
      'automl_users_undeleted_object',
      'automl_project_rights_undeleted_object',
    ]),
    ...mapState(['platform_status']),
  },
  beforeMount() {
    this.fetch_collections(['bricks'])
  },
  methods: {},
}
</script>
